import { render, staticRenderFns } from "./updateRoles.vue?vue&type=template&id=2fbe1a85"
import script from "./updateRoles.vue?vue&type=script&lang=js"
export * from "./updateRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports